export default __webpack_public_path__ + "static/media/007-chamber.434c9d62.png";